import { Badge, Card, DataTable, Link, Text } from '@shopify/polaris';
import helpers from 'helpers/index';
import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { TypedOrders, useGetOrders } from 'queries/orders.query';
import dateandtime from 'date-and-time';
import SimpleFilter from 'components/simpleFilter';
import Pagination from 'components/pagination';

export default function CustomerTicketList() {
  /**
   * Get all campaign this customer belong to...
   */
  let { customer_id } = useParams();
  const initialQuery = {
    limit: 20,
    customer_id: customer_id,
    sort: 'departure_date:desc',
    page: 1,
  };
  const [mainQuery, setMainQuery] = useState(initialQuery);

  const { data, isLoading } = useGetOrders(mainQuery);

  const [totalItems, setTotalItems] = useState<number>(0);
  const [entities, setEntities] = useState<TypedOrders[]>([]);
  useEffect(() => {
    if (data) {
      setEntities(data.entities);
      setTotalItems(data.totalItems);
    }
  }, [data]);

  const getTicketStatus = (status) => {
    switch (status) {
      case 9:
        return <Badge tone={'read-only'}>HỦY</Badge>;
      case 0:
        return <Badge tone={'read-only'}>NHÁP</Badge>;
      case 1:
        return <Badge tone={'success-strong'}>ĐÃ XẾP CHUYẾN</Badge>;
      case 2:
        return <Badge tone={'success-strong'}>TRONG CHUYẾN</Badge>;
      case 3:
        return <Badge tone={'success-strong'}>HOÀN THÀNH</Badge>;
    }
  };

  const filterCallback = useCallback((_value: any) => {
    if (_value === false) {
      return setMainQuery(initialQuery);
    } else {
      setMainQuery((oldValue) => {
        return { ...oldValue, ..._value };
      });
    }
  }, []);

  /**
   * Change page number
   * Must be mainQuery or it will reset mainQuery. BUG!
   */
  const onChangePagination = useCallback((numPage: number, limit: number) => {
    setMainQuery((prevMainQuery) => ({ ...prevMainQuery, page: numPage, limit: limit }));
  }, []);

  return (
    <>
      <Card padding="0">
        {entities?.length > 0 ? (
          <>
            <SimpleFilter
              onCallback={filterCallback}
              loading={isLoading}
              options={[]}
              // options={[{ label: 'Chưa diễn ra', value: `gte:${new Date(new Date().setHours(0)).getTime()}`, field: 'trip.DepartureTimeTimestamp' }]}
              sortField={[
                {
                  label: 'Ngày đi',
                  field: 'departure_date',
                },
              ]}
            />
            <DataTable
              verticalAlign="middle"
              stickyHeader={false}
              columnContentTypes={['text', 'text', 'text', 'text', 'text', 'text', 'text', 'text', 'text', 'text', 'text', 'text', 'numeric']}
              headings={[
                'Code',
                'Ngày đi',
                'TT.Vận chuyển',
                'Hành trình',
                'Số vé',
                'Chuyến',
                'Đón/trả',
                'Số tiền',
                'Ghi chú',
                'Người đặt',
                'Thanh toán',
                'Ngày tạo',
              ]}
              rows={entities?.map((order) => {
                const {
                  id,
                  order_code,
                  departure_date,
                  dropoff_address,
                  pickup_address,
                  journey,
                  total_must_pay,
                  note,
                  author_data,
                  order_status,
                  payment_status,
                  journey_id,
                  createdAt,
                  total_seat,
                  ticket,
                } = order;

                let trip_hour = dateandtime.format(new Date(Number(departure_date)), 'HH:mm');
                let trip_date_reformat = dateandtime.format(new Date(Number(departure_date)), 'YYYY-MM-DD');
                let allDrivers = [];
                let trip_manifest_ticket = null;

                if (ticket && typeof ticket[0] !== 'undefined') {
                  allDrivers = ticket[0]?.trip_manifest_ticket?.trip_manifest?.trip_manifest_driver || null;
                  trip_manifest_ticket = ticket[0]?.trip_manifest_ticket;
                }

                return [
                  trip_manifest_ticket ? (
                    <Link
                      url={`/ticket_managers?d=${trip_date_reformat}&journey_id=${journey_id}&htext=${trip_hour}&h=${trip_manifest_ticket?.trip_manifest.time_id}#${id}`}
                    >
                      <strong>{order_code}</strong>
                    </Link>
                  ) : (
                    <strong>{order_code}</strong>
                  ),

                  <>
                    <Text as="h3" variant="headingMd">
                      {trip_hour}
                    </Text>
                    <Text as="p" tone="subdued">
                      {trip_date_reformat}
                    </Text>
                  </>,
                  getTicketStatus(order_status),
                  journey ? <Text as="span">{journey?.journey_name}</Text> : '--',
                  total_seat,
                  !helpers.isEmpty(allDrivers)
                    ? allDrivers.map((al: any) => (
                        <div>
                          {al.driver_data.display_name} ({al.driver_data.user_phonenumber})
                        </div>
                      ))
                    : '-',
                  <>
                    <Text as="p">{pickup_address ?? '--'}</Text>
                    <Text as="p">{dropoff_address ?? '--'}</Text>
                  </>,

                  helpers.formatNumber(total_must_pay),

                  note ?? '--',
                  author_data?.display_name ?? '--',
                  <Badge tone={payment_status === 0 ? 'critical' : 'success-strong'}>
                    {payment_status === 0 ? 'PENDING' : payment_status === 1 ? 'OK' : 'REFUND'}
                  </Badge>,
                  <>
                    <Text as="h3" variant="headingMd">
                      {dateandtime.format(new Date(Number(createdAt)), 'HH:mm')}
                    </Text>
                    <Text as="p" tone="subdued">
                      {dateandtime.format(new Date(Number(createdAt)), 'DD-MM-YYYY')}
                    </Text>
                  </>,
                ];
              })}
              hideScrollIndicator
              hasZebraStripingOnData
              increasedTableDensity
            />
          </>
        ) : null}
      </Card>

      <br />
      {totalItems > 0 ? (
        <Pagination
          TotalRecord={totalItems}
          onChange={onChangePagination}
          pageSize={Number(mainQuery.limit)}
          activeCurrentPage={Number(mainQuery.page)}
        />
      ) : null}
    </>
  );
}

